<template>
  <div>
    <!-- Layout minimal pour les pages de cagnotte publique — sans header/footer Donoor.org -->
    <slot />
  </div>
</template>
